const MESH = 'mesh';
const FORCED_MESH = 'mesh forzado';

export default {
  MESH,
  FORCED_MESH,
};
